var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyClientsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_3360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4171 5.95846C14.4171 6.59953 14.6718 7.21434 15.1251 7.66764C15.5784 8.12094 16.1932 8.37561 16.8343 8.37561C17.4753 8.37561 18.0901 8.12094 18.5434 7.66764C18.9967 7.21434 19.2514 6.59953 19.2514 5.95846C19.2514 5.3174 18.9967 4.70259 18.5434 4.24929C18.0901 3.79598 17.4753 3.54132 16.8343 3.54132C16.1932 3.54132 15.5784 3.79598 15.1251 4.24929C14.6718 4.70259 14.4171 5.3174 14.4171 5.95846Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4599 14.4188V13.2102C20.4599 11.2077 18.8367 9.58441 16.8342 9.58441C15.4687 9.58441 14.2795 10.3392 13.6611 11.4544",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74854 5.95846C4.74854 6.59953 5.0032 7.21434 5.4565 7.66764C5.9098 8.12094 6.52461 8.37561 7.16568 8.37561C7.80674 8.37561 8.42155 8.12094 8.87486 7.66764C9.32816 7.21434 9.58282 6.59953 9.58282 5.95846C9.58282 5.3174 9.32816 4.70259 8.87486 4.24929C8.42155 3.79598 7.80674 3.54132 7.16568 3.54132C6.52461 3.54132 5.9098 3.79598 5.4565 4.24929C5.0032 4.70259 4.74854 5.3174 4.74854 5.95846Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53992 14.4188V13.2102C3.53992 11.2077 5.16324 9.58441 7.16571 9.58441C8.53119 9.58441 9.72038 10.3392 10.3388 11.4544",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58423 13.2072C9.58423 13.5246 9.64675 13.8389 9.76822 14.1322C9.8897 14.4254 10.0677 14.6919 10.2922 14.9164C10.5166 15.1408 10.7831 15.3189 11.0764 15.4403C11.3696 15.5618 11.6839 15.6243 12.0014 15.6243C12.3188 15.6243 12.6331 15.5618 12.9264 15.4403C13.2196 15.3189 13.4861 15.1408 13.7105 14.9164C13.935 14.6919 14.113 14.4254 14.2345 14.1322C14.356 13.8389 14.4185 13.5246 14.4185 13.2072C14.4185 12.5661 14.1639 11.9513 13.7105 11.498C13.2572 11.0447 12.6424 10.79 12.0014 10.79C11.3603 10.79 10.7455 11.0447 10.2922 11.498C9.83889 11.9513 9.58423 12.5661 9.58423 13.2072Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6274 20.4585C15.6274 18.456 14.0041 16.8328 12.0016 16.8328C9.99917 16.8328 8.37585 18.456 8.37585 20.4585",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_3360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyClientsNew);
export default __webpack_public_path__ + "static/media/MyClientsNew.14ad0476d19323d391aedd66651ab664.svg";
export { ForwardRef as ReactComponent };